module.exports = __webpack_public_path__ + "img/product-placeholder-69.7d8f306.png";